import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { forgotPassword } from 'actions/user';

import Button from 'components/Button';
import Message from 'components/Message';
import Link from 'components/Link';
import { H3, SecondaryHierarchyText } from 'components/Common/Typography';
import { BlockSpace, InlineSpace } from 'components/Common/Spacing';

import styles from './ForgotPassword.css';

const ENTER_KEY_CODE = 13;
export default function ForgotPassword({ title }) {
  useStyles(styles);

  const dispatch = useDispatch();
  const [email, setEmail] = useState('');

  const { forgotPasswordError, forgotPasswordMessage } = useSelector(
    state => state.user,
  );

  const postForgotPassword = async () => {
    await dispatch(
      forgotPassword({
        email,
      }),
    );
  };

  const onKeyDown = event => {
    if (event.keyCode === ENTER_KEY_CODE) {
      postForgotPassword();
    }
  };

  return (
    <div>
      <div className={styles.container}>
        <H3>{title}</H3>
        <BlockSpace size={200} />
        {forgotPasswordError && (
          <Message messageType="error">{forgotPasswordError}</Message>
        )}
        {forgotPasswordMessage && (
          <Message messageType="success">{forgotPasswordMessage}</Message>
        )}
        <form>
          <div>
            <label htmlFor="email">
              Email address:
              <input
                className={styles.input}
                id="email"
                type="email"
                name="email"
                value={email}
                onChange={e => {
                  setEmail(e.target.value);
                }}
                onKeyDown={onKeyDown}
              />
            </label>
          </div>
          <BlockSpace size={100} />
          <div>
            <Button onClick={postForgotPassword}>Send</Button>
          </div>
        </form>
        <BlockSpace size={200} />
        <div>
          <SecondaryHierarchyText>
            Back to
            <InlineSpace size={25} />
            <Link to="/login">Login</Link>
          </SecondaryHierarchyText>
        </div>
      </div>
    </div>
  );
}

ForgotPassword.propTypes = {
  title: PropTypes.string.isRequired,
};
